/* Nombra Studio — vista previa orientativa del collar con nombre (dibujo en SVG) */
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  // Tipos de letra de la web -> tipografía web parecida (orientativa)
  var FAMILIAS = {
    'Rebecca': "'Great Vibes', cursive",
    'Marian': "'Kaushan Script', cursive",
    'Custom': "'Satisfy', cursive",
    'Ashely': "'Yellowtail', cursive",
    'Amanda': "'Courgette', cursive",
    'Alejandra': "'Allura', cursive"
  };
  var METALES = {
    'plata': ['#eef0f3', '#a4a9b1', '#6f757e'],
    'oro': ['#f6e5ab', '#d2ad55', '#a9803f'],
    'oro rosado': ['#f9dfd5', '#dfa797', '#b9776a']
  };
  var DROP = { '40': 190, '45': 212, '50': 234 };
  var uid = 0;

  function el(name, attrs) {
    var e = document.createElementNS(NS, name);
    Object.keys(attrs || {}).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function render(contenedor, estado) {
    if (!contenedor) return;
    var nombre = (estado.nombre || '').trim() || 'Tu nombre';
    var fuente = FAMILIAS[estado.fuente] || FAMILIAS['Rebecca'];
    var metal = METALES[(estado.metal || 'oro').toLowerCase()] || METALES['oro'];
    var km = String(parseInt(estado.longitud, 10) || 40);
    var y = DROP[km] || 215;
    var id = 'nbv' + (++uid);

    contenedor.innerHTML = '';
    var svg = el('svg', { viewBox: '0 0 600 360', role: 'img', 'aria-label': 'Vista previa del collar con el nombre ' + nombre });
    var defs = el('defs');
    var fondo = el('linearGradient', { id: id + 'f', x1: '0', y1: '0', x2: '0', y2: '1' });
    [['0', '#fbf7ef'], ['1', '#efe4d1']].forEach(function (p) { fondo.appendChild(el('stop', { offset: p[0], 'stop-color': p[1] })); });
    var g = el('linearGradient', { id: id + 'm', x1: '0', y1: '0', x2: '1', y2: '1' });
    [['0', metal[0]], ['0.5', metal[1]], ['1', metal[2]]].forEach(function (p) { g.appendChild(el('stop', { offset: p[0], 'stop-color': p[1] })); });
    var sombra = el('filter', { id: id + 's', x: '-10%', y: '-30%', width: '120%', height: '170%' });
    sombra.appendChild(el('feDropShadow', { dx: '0', dy: '5', stdDeviation: '4', 'flood-color': '#000', 'flood-opacity': '.28' }));
    defs.appendChild(fondo); defs.appendChild(g); defs.appendChild(sombra);
    svg.appendChild(defs);
    svg.appendChild(el('rect', { width: '600', height: '360', fill: 'url(#' + id + 'f)' }));

    var texto = el('text', { x: '300', y: String(y + 34), 'text-anchor': 'middle', 'font-size': '136', fill: 'url(#' + id + 'm)', stroke: metal[2], 'stroke-width': '.7', 'paint-order': 'stroke', filter: 'url(#' + id + 's)' });
    texto.setAttribute('style', 'font-family:' + fuente);
    texto.textContent = nombre;
    svg.appendChild(texto);
    contenedor.appendChild(svg);

    // Ajuste al ancho disponible y anillas
    var colocar = function () {
      var bb;
      try { bb = texto.getBBox(); } catch (e) { return; }
      var maximo = 470;
      if (bb.width > maximo) {
        texto.setAttribute('font-size', String(136 * maximo / bb.width));
        bb = texto.getBBox();
      }
      var izq = bb.x - 6, der = bb.x + bb.width + 6, ay = bb.y + bb.height * 0.58;
      var cadena = { fill: 'none', stroke: metal[1], 'stroke-width': '3.6', 'stroke-linecap': 'round', 'stroke-dasharray': '0.1 5.4' };
      var cadena2 = { fill: 'none', stroke: metal[2], 'stroke-width': '1.4', 'stroke-linecap': 'round' };
      var p1 = 'M 40,-10 C 40,' + (ay - 70) + ' ' + (izq - 70) + ',' + ay + ' ' + izq + ',' + ay;
      var p2 = 'M 560,-10 C 560,' + (ay - 70) + ' ' + (der + 70) + ',' + ay + ' ' + der + ',' + ay;
      [p1, p2].forEach(function (d) {
        var linea = el('path', Object.assign({ d: d }, cadena2)); linea.setAttribute('opacity', '.55'); svg.insertBefore(linea, texto);
        svg.insertBefore(el('path', Object.assign({ d: d }, cadena)), texto);
      });
      [izq, der].forEach(function (x) { svg.insertBefore(el('circle', { cx: String(x), cy: String(ay), r: '5', fill: 'none', stroke: metal[2], 'stroke-width': '2' }), texto); });
      var leyenda = el('text', { x: '300', y: '344', 'text-anchor': 'middle', 'font-size': '24', fill: '#6b6258' });
      leyenda.setAttribute('style', "font-family:'Inter',system-ui,sans-serif;letter-spacing:.03em");
      leyenda.textContent = 'Cadena de ' + km + ' cm · vista orientativa';
      svg.appendChild(leyenda);
    };
    if (document.fonts && document.fonts.load) {
      document.fonts.load('136px ' + fuente.split(',')[0], nombre).then(colocar, colocar);
    } else { colocar(); }
  }

  window.NBVista = { render: render };

  // ---- Ficha de producto ----
  function valorOpcion(nombre) {
    var r = null;
    document.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (leg && leg.textContent.trim().toLowerCase() === nombre) { var c = fs.querySelector('input[type="radio"]:checked'); if (c) r = c.value; }
    });
    return r;
  }
  function pintarFicha() {
    var cont = document.querySelector('[data-nb-vista-ficha]');
    if (!cont) return;
    var nombreInput = document.querySelector('input[name="properties[Nombre]"]');
    var fuente = document.querySelector('.nb-fuente input:checked');
    render(cont, {
      nombre: nombreInput ? nombreInput.value : '',
      fuente: fuente ? fuente.value : 'Rebecca',
      metal: valorOpcion('metal') || 'Oro',
      longitud: valorOpcion('longitud') || '40 cm'
    });
  }
  var pendiente = null;
  function programar() { clearTimeout(pendiente); pendiente = setTimeout(pintarFicha, 120); }
  if (document.querySelector('[data-nb-vista-ficha]') || document.readyState === 'loading') {
    document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('input[name="properties[Nombre]"]')) programar(); });
    document.addEventListener('change', programar);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(pintarFicha, 250); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintarFicha); else pintarFicha();
  }
})();
